package ru.it_mozaika.components

import csstype.PropertiesBuilder
import mui.material.*
import mui.material.styles.PaletteColor
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import react.FC
import react.ReactNode
import react.dom.aria.ariaLabel
import web.cssom.*

//external interface AvatarButtonProps: PropsWithChildren,
//    react.dom.html.HTMLAttributes<HTMLDivElement>,
//    PropsWithSx {
//    var label: String
//    var color: PaletteColor?
//    var tooltipTitle: String
//    var isDisabled: Boolean?
//   override var onClick: MouseEventHandler<HTMLDivElement>?
//}

external interface AvatarButtonProps: ButtonProps {
    var label: String
    var palettecolor: PaletteColor?
    var tooltipTitle: String
}

val AvatarButton = FC<AvatarButtonProps> { props ->
    val theme = useTheme<Theme>()
    ButtonBase {
        +props
//        disabled = props.isDisabled ?: false
        sx {
            borderRadius = 8.px
            overflow = Overflow.hidden
            +props.sx
        }
        focusRipple = false
        ariaLabel = props.label
        Tooltip{
            title = ReactNode(props.tooltipTitle)
            Avatar {
                variant = AvatarVariant.rounded
                sx {
                    +theme.typography.commonAvatar.unsafeCast<PropertiesBuilder>()
                    +theme.typography.mediumAvatar.unsafeCast<PropertiesBuilder>()
                    transition = Transition(TransitionProperty.all, .2.s, TransitionTimingFunction.easeInOut)
//                    background = props.color?.light ?: theme.palette.secondary.light
                    background = theme.palette.secondary.light
                    color = theme.palette.secondary.dark
//                    color = props.color?.dark ?: theme.palette.secondary.dark
                    "&:hover" {
//                        background = props.color?.dark ?: theme.palette.secondary.dark
//                        color = props.color?.light ?: theme.palette.secondary.light
                        background = theme.palette.secondary.dark
                        color = theme.palette.secondary.light
                    }
                }
                +props.children
            }
        }
    }
}